module.exports = __webpack_public_path__ + "img/experience13.5db6cde3.jpg";